import { Component, OnInit } from '@angular/core';
import {ApiPathsService} from "../../api-paths.service";
import { ApiRestService } from '../_services/api-rest.service';
import {DatePipe} from "@angular/common";
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NoteModalComponent } from '../note-modal/note-modal.component';



@Component({
  selector: 'app-bilancio',
  templateUrl: './bilancio.component.html',
  styleUrls: ['./bilancio.component.scss']
})
export class BilancioComponent implements OnInit {
    contoIniziale:number = 0;
    contoFinale:number;
    ospitiList: any[];
    fattureList: any[];
    fattureEffettive: any[] = [];
    lastFatture: any[];
    dataList:any[] = [];
    giorniList: string[];
    bilancio:any
    filtro: any = {};
    id_bilancio:number;
    nota:string;
    stato = "Lavorazione";
    riesamina = false;
    modal : NgbModalRef;

    constructor(
      private apiPaths:ApiPathsService, 
      private apiRestService:ApiRestService, 
      private datePipe:DatePipe,
      private route: ActivatedRoute,
      private router:Router,
      private modalService:NgbModal
    ){

    }

    ngOnInit(){
      this.filtro.inizio = this.datePipe.transform(new Date() ,'yyyy-MM-dd')
      this.route.params.subscribe(data => this.id_bilancio = data['id'])
      this.apiPaths.ClassicPost('/anagrafica/clienti/list', {
        page: 0,
        size: 10,
        ruolo: 'C',
        inseriti: true,
        nome:this.filtro?.ospite
      }).subscribe(data => {
        this.ospitiList = data?.data;
            this.Refresh()
        })
    }

     Refresh(){
      if(this.id_bilancio)
        this.apiRestService.getBilancio({id:this.id_bilancio,page: 0,size: 10}).subscribe(
          data => {
            this.bilancio = data
            this.bilancio.fattureObject.forEach(
              fattura =>{
                fattura.voci[1].prezzo = Math.abs(fattura.voci[1].prezzo)
              }
            )
            if(this.bilancio.note == 'null')
              this.bilancio.note = ""
            this.initFilter()
            this.dataList = [];
            this.ospitiList.forEach(ospite => {this.dataList.push({nome: ospite.nominativo, id_cliente:ospite.id, fattura: this.generateFatture(ospite)})})
            console.log("Data List", this.dataList)
          }
        )
      else{
        this.initFilter();
        this.generateDateArray();
        this.dataList = [];
        this.ospitiList.forEach(ospite => {this.dataList.push({nome: ospite.nominativo, id_cliente:ospite.id, fattura: this.generateFakeFatture(ospite) })})
        console.log("Data senza id", this.dataList)
      }
    }

    generateFakeFatture(ospite){
      return this.giorniList?.map(giorno => {
        return {cliente: ospite.id, nominativo:ospite.nominativo,data_emissione:giorno, data_prevista:giorno, voci:[{voce:" ", quantita:1, prezzo:0, um_id: 64, iva:22},{voce:" ", quantita:1, prezzo:0, um_id: 64, iva:22}]}
      })
    }

    generateFatture(ospite) {
      return this.giorniList?.map(giorno=> {
        var val =  this.bilancio.fattureObject.find(fattura=> (fattura.nominativo == ospite.nominativo) && this.DateDiff(new Date(giorno),new Date(fattura.data_emissione)) < 1) ?? {cliente: ospite.id, nominativo:ospite.nominativo,data_emissione:giorno, data_prevista:giorno, voci:[{voce:" ", quantita:1, prezzo:0, um_id: 64, iva:22},{voce:" ", quantita:1, prezzo:0, um_id: 64, iva:22}]};
        return val;
      })
    }


    generateDateArray() {
        if (this.filtro?.inizio && this.filtro?.fine) {
          const startDate = new Date(this.filtro.inizio);
          const endDate = new Date(this.filtro.fine);
          this.giorniList = [];

          let currentDate = startDate;
          while (currentDate <= endDate) {
            const formattedDate = this.datePipe.transform(currentDate, 'yyyy-MM-dd');
            this.giorniList.push(formattedDate);
            currentDate.setDate(currentDate.getDate() + 1);
          }

          console.log("Giorni List:", this.giorniList);
    }
    }

    initFilter(){
      if(!this.id_bilancio){
          let inizioData: Date;
          if (this.filtro.inizio) {
              inizioData = new Date(this.filtro.inizio);
          } else {
              inizioData = new Date();
              this.filtro.inizio = this.datePipe.transform(inizioData, 'yyyy-MM-dd');
          }
          let fineData = new Date(inizioData);
          fineData.setDate(inizioData.getDate() + 6);
          this.filtro.fine = this.datePipe.transform(fineData, 'yyyy-MM-dd');
          this.calculateCassaIniziale();
      } else {
          this.filtro.inizio = this.datePipe.transform(new Date(this.bilancio?.dataInizio), 'yyyy-MM-dd');
          this.filtro.fine = this.datePipe.transform(new Date(this.bilancio?.dataFine), 'yyyy-MM-dd');
          this.generateDateArray();
          this.calculateCassaIniziale();
      }
  }
  

    DateDiff(date1: Date, date2: Date){
        const timeDiff = Math.abs(date2.getTime() - date1.getTime())
        const diffInDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
        return diffInDays;
    }

    setVoce(fattura: any) {
      if (fattura.voci && fattura.voci.length > 1) {
          fattura.voci[1].voce = fattura.voci[0].voce;
      }
    }

    calculateCassaElemento(voce:any[]){
      return voce[0].prezzo + voce[1].prezzo
    }

    calculateCassaIniziale(){
      this.apiRestService.getListaBilanci({page:0, size:10, periodo:false}).subscribe(
        data =>{
          var arrayCassaFinale = data?.data
          var cassaPrecedente = arrayCassaFinale[arrayCassaFinale.length - 1].valore
          this.contoIniziale = cassaPrecedente
        });

    }

    populateFattureEffettive() {
      let cassaAttuale = 0
      this.fattureEffettive = []; 
      let totalFatture = 0;
      let processedCount = 0;
    
      this.dataList.forEach(data => {
        totalFatture += data.fattura.length;
      });

      this.dataList.forEach(data => {
        data.fattura.forEach(x => {
          x.voci[1].prezzo = -Math.abs(x.voci[1].prezzo);
          if (x?.id) {
            this.apiRestService.updateFattura(x).subscribe(() => {
              cassaAttuale += this.calculateCassaElemento(x.voci)
              this.fattureEffettive.push(x.id);
              processedCount++;
              if (processedCount === totalFatture) {
                this.save(cassaAttuale);
              }
            });
          } else {
            if ((x.voci[0].prezzo != 0 && x.voci[0].voce != "") || (x.voci[1].prezzo != 0 && x.voci[1].voce != "")) {
              this.apiRestService.addFattura(x).subscribe(data => {
                x.id = data.id;
                cassaAttuale += this.calculateCassaElemento(x.voci)
                this.fattureEffettive.push(x.id);
                processedCount++;
                if (processedCount === totalFatture) {
                  this.save(cassaAttuale);
                }
              });
            } else {
              processedCount++;
              if (processedCount === totalFatture) {
                this.save(cassaAttuale);
              }
            }
          }
        });
      });
    }
    
    save(cassaAttuale) {
      if (this.id_bilancio) {
        this.bilancio.valore = cassaAttuale
        this.bilancio.fatture = this.fattureEffettive
        // this.bilancio.fatture.forEach(
        //   fattura =>{
        //     fattura.voci[1].prezzo = -(fattura.voci[1].prezzo)
        //   }
        // )
        this.apiRestService.updateBilancio(this.bilancio).subscribe();
      } else {
        this.changeStato('Salva', cassaAttuale);
      }
    }
    
    

    calculateDiff(fatture:any[]):number{
      if (!fatture || fatture.length === 0) return 0;
      var finale = 0
      fatture.forEach(
        fattura => 
          finale = finale + (fattura?.voci[0]?.prezzo + fattura?.voci[1]?.prezzo)
      )
      return finale
    }


    changeStato(stato:string, cassaAttuale = 0){
      this.modal = this.modalService.open(NoteModalComponent, {centered:true})

      this.modal.componentInstance.tipoNote = stato; 

      switch(stato){
        case 'Valida':
          this.modal.componentInstance.tipoNotePrecedente = 'Approva'
          this.modal.componentInstance.notePrecedenti = this.bilancio.noteApprovazione
        break;
        case 'Riesamina':
          this.modal.componentInstance.tipoNotePrecedente = 'Approva'
          this.modal.componentInstance.notePrecedenti = this.bilancio.noteApprovazione
        break;
        case 'Approva':
          this.modal.componentInstance.tipoNotePrecedente = 'In Lavorazione'
          this.modal.componentInstance.notePrecedenti = this.bilancio.note
        break;
        case 'Salva':
          this.modal.componentInstance.tipoNote = 'In Lavorazione'; 
          this.modal.componentInstance.hasPrecedente = false
        break;
      }

      this.modal.result.then((result) =>{
        switch(stato){
          case 'Valida':
            this.bilancio.noteValidazione = result
            this.bilancio.data_pagamento_e = this.datePipe.transform(new Date() ,'yyyy-MM-dd')
            this.bilancio.fattureObject.forEach(
              x => {
                x.voci[1].prezzo = -Math.abs(x.voci[1].prezzo);
                x.data_pagamento_e = this.datePipe.transform(new Date() ,'yyyy-MM-dd');
                this.apiRestService.updateFattura(x).subscribe();
              }
            )
            this.apiRestService.updateBilancio(this.bilancio).subscribe()
          break;
          case 'Approva':
            this.bilancio.noteApprovazione = result
            this.bilancio.dataRiesamina = null
            this.bilancio.data_pagamento_p = this.datePipe.transform(new Date() ,'yyyy-MM-dd')
            this.bilancio.fattureObject.forEach(
              x => {
                x.voci[1].prezzo = -Math.abs(x.voci[1].prezzo);
                x.dataRiesamina = null
                x.data_pagamento_p = this.datePipe.transform(new Date() ,'yyyy-MM-dd')
                this.apiRestService.updateFattura(x).subscribe();
              }
            )
            this.apiRestService.updateBilancio(this.bilancio).subscribe()
          break;
          case 'Riesamina':
            this.bilancio.noteRiesaminare = result
            this.bilancio.data_pagamento_p = null
            this.bilancio.data_pagamento_e = null
            this.bilancio.dataRiesamina = this.datePipe.transform(new Date() ,'yyyy-MM-dd')
            this.bilancio.fattureObject.forEach(
              x => {
                x.voci[1].prezzo = -Math.abs(x.voci[1].prezzo);
                x.data_pagamento_p = null
                x.data_pagamento_e = null
                x.dataRiesamina = this.datePipe.transform(new Date() ,'yyyy-MM-dd')
                this.apiRestService.updateFattura(x).subscribe();
              }
            )
            this.apiRestService.updateBilancio(this.bilancio).subscribe()
          break;
          case 'Salva':
            this.apiRestService.addBilancio({
              data_prevista: this.filtro?.inizio,
              note: result,
              dataInizio: this.filtro?.inizio,
              dataFine: this.filtro?.fine,
              fatture: this.fattureEffettive,
              valore: this.contoIniziale + cassaAttuale,
              valorePrecedente: this.contoIniziale,
            }).subscribe(data=>this.router.navigate([`/primanota/bilancio/${data.id}`]));
          break;
        }
      })

      this.stato = stato
    }

    goListaBilanci(){
      this.router.navigate(['primanota/lista-bilancio'])
    }




}
